<template>
  <div>
        <!--没有搜索到相关结果-->
        <div class="itemcard">
            <div class="no-search-result">
            <img src="/images/order/icon_22.png"/>
            <div class="no-search-text">
                <p class="one">暂无相关订单。</p>
                <p class="two">请稍后再试</p>
                <!-- <el-button type="primary" @click="clearSearch" v-if="Object.keys(this.searchCon).length > 0"    class="no-button">清除选项</el-button> -->
            </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'NoPrompt',
  components: {},
  props: {},
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
    .no-search-result{
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 0px 7px #eee;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        padding: 52px 0;
        margin-top: 20px;
        img{
        width: 120px;
        }  
    }
    .no-search-text{
        margin-left: 14px;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .one{
        font-weight: bold;
        font-size: 16px;
        }
        .two{
        color: #666;
        margin: 6px 0;
        }
    }
</style>
